import traitAcronymImg from 'assets/images/data-tooltip-1.png';
import traitDataImg from 'assets/images/data-tooltip-2.png';
import graphColumnImg from 'assets/images/data-tooltip-3.png';
import topPercentileImg from 'assets/images/percentile-tooltip-1.png';
import bottomPercentileImg from 'assets/images/percentile-tooltip-2.png';
import { DropdownItem } from 'components/dropdown/dropdown-item';
import { RelativeTooltipContent } from 'components/relative-tooltip/relative-tooltip-content';
import { DisplayFormat } from 'shared/display-format.enum';
import { HighlightsTitle } from '../highlights.enum';
import { DisplayOption } from './display-option.enum';

export const displayOptionsTooltipContent = [
  {
    type: DisplayOption.DataDisplay,
    content: {
      title: 'How to read ASBVs',
      summary: '',
      tabletColumns: [10, 6, 6],
      desktopColumns: [5, 4, 3],
      subTitle: [DisplayFormat.Data, DisplayFormat.Graph/* , DisplayFormat.Group */],
      sections: [
        {
          type: `${DisplayFormat.Data} & ${DisplayFormat.Condensed}`,
          image: [traitAcronymImg, traitDataImg],
          content: {
            desc: ['Abbreviated ASBV Trait name - Selecting a heading will sort animals by that ASBV value.'],
            list: [
              'For more information on ASBVs <a href="http://www.sheepgenetics.org.au/Getting-started/ASBVs-and-Indexes" target="_blank" rel="noopener">visit here</a>',
              'Accuracy - Reflects the amount of information available for each trait. As the amount of information increases the accuracy increases',
              'Percentile - The percentile band the animal sits in for a trait compared to the rest of the anaylsis',
              'Tags - Indicate additional information on the animal e.g. use in a reference flock or genomic test used',
            ],
          },
        },
        {
          type: DisplayFormat.Graph,
          image: [graphColumnImg],
          content: {
            desc: [
              'Graph view is a visual way of interpreting ASBVs. It plots where an individual animal sits on the percentile band for each ASBV.',
              'The point on the  plot represents where the animals ASBV sits in relation to the percentile band compared to the rest of the anaylsis for a particular trait.',
            ],
          },
        },
        // uncomment group title and section when view will be developed
        /* {
          type: DisplayFormat.Group,
          content: {
            desc: [
              'The grouped traits view shows the percentile for each of the key trait groups related to the index.',
              'The weighting of traits in each of the groups is related to the production system index selected. Different indexes have different weights of traits in the groupings.',
            ],
          },
        }, */
      ],
    } as RelativeTooltipContent,
  },
  {
    type: DisplayOption.PercentileHighlights,
    content: {
      title: 'How to read percentile highlights',
      summary: 'Percentile highlights indicate where an animal sits in relation to other animals in the anaylsis from the current year drop for top and bottom percentiles. This shows where animals rank for that trait within the analysis. Some traits that have an optimum value, such as birth weight (BWT), will not be displayed with top or bottom values.',
      tabletColumns: [6, 6],
      subTitle: [HighlightsTitle.Top, HighlightsTitle.Bottom],
      sections: [
        {
          type: HighlightsTitle.Top,
          image: [topPercentileImg],
          content: {
            desc: ['Animals that rank in the top 5%, 10% and 20% percentile for a particular trait or index will be marked using purple, blue and green respecitvely.'],
          },
        },
        {
          type: HighlightsTitle.Bottom,
          image: [bottomPercentileImg],
          content: {
            desc: ['Highlight animals that rank within the bottom 10% or 20% percentile for a particular trait or index.'],
          },
        },
      ],
    } as RelativeTooltipContent,
  },
];

/**
 * Returns content of selected tooltip.
 * @param type tooltip to show
 */
export const getDisplayOptionsTooltipContent = (type: DisplayOption): RelativeTooltipContent | undefined => {
  let content;
  displayOptionsTooltipContent.forEach((t: any) => {
    if (t.type === type) {
      content = t.content;
    }
  });
  return content;
};

/**
 * Matches sorting value with sorting option by id or value.
 * @param items List of sorting options to select for sort
 * @param itemValue Present sort selection value eg. PWT
 */
export const findSortingOption = (items: DropdownItem[], itemValue: string) => {
  const el: DropdownItem[] = items.filter((item) => item.value === itemValue || item.id === itemValue);
  return el[0];
};
